/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
    enabled: true, // set false to disable splash screen
    animation: splashAnimation,
    duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
    animated: true // Set to false to use static SVG
};

const greeting = {
    username: "matteomoro996",
    title: "Hey, it's Matteo!",
    subTitle:
        emoji("A passionate Freelancer ML Engineer 🤖 I build AI models in Python and PyTorch to uncover insights and enable automation. My work combines data analysis, model creation, and rigorous testing to develop AI systems suited to the required needs. I love to stay toe-on-toe with the latest releases in the generative AI applications.")
    ,
    resumeLink:
        "https://drive.google.com/file/d/17ye9h-baLt7tiN4ywfgALL5dMaThFaUC/view?usp=sharing",
    resumeLink2:
        "https://drive.google.com/file/d/1XBkWtKLgX-eaORPdAJYxA6LzSfGFmurO/view?usp=sharing",
    displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
    github: "https://github.com/devilteo911",
    linkedin: "https://www.linkedin.com/in/matteo-moro-ml-engineer/",
    gmail: "matteomoro996@gmail.com",
    medium: "https://medium.com/@matteomoro996",
    stackoverflow: "https://stackoverflow.com/users/15782934/devilteo911",
    // Instagram, Twitter and Kaggle are also supported in the links!
    // To customize icons and social links, tweak src/components/SocialMedia
    display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
    title: "What I do",
    subTitle: "ML ENGINEER WHO WANTS TO EXPLORE EVERY FIELD OF APPLICATION",
    skills: [
        emoji(
            "🧩 I work on raw data to make it ready for accurate analysis"
        ),
        emoji("🏋🏻‍♂️ Train model from scratch and deploy it on docker containers"),
        emoji(
            "📈 Use 🤗 to adapt or fine-tune pre-trained models to specific tasks"
        )
    ],

    /* Make Sure to include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

    softwareSkills: [
        {
            skillName: "python",
            fontAwesomeClassname: "fab fa-python"
        },
        {
            skillName: "pytorch",
            fontAwesomeClassname: "fas fa-fire"
        },
        {
            skillName: "mongodb",
            fontAwesomeClassname: "fas fa-database"
        },
        {
            skillName: "aws",
            fontAwesomeClassname: "fab fa-aws"
        },
        {
            skillName: "docker",
            fontAwesomeClassname: "fab fa-docker"
        },
    ],
    display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
    display: true, // Set false to hide this section, defaults to true
    schools: [
        {
            schoolName: "Padua University",
            logo: require("./assets/images/paduaLogo.png"),
            subHeader: "Master of Science in ICT for Internet and Multimedia",
            duration: "September 2019 - October 2021",
            desc: "I focused my studies on Artificial Intelligence and Machine Learning. My thesis is about comparing diverse machine and deep learning approaches on vulnerable mobile web communications.",
            descBullets: [
                "Final grade: 110/110",
                "Worked alone and in teams in various projects",
                "Seen some diverse application fields of AI, such as robotics, bioinformatics, computer vision, etc."
            ]
        },
        {
            schoolName: "Padua University",
            logo: require("./assets/images/paduaLogo.png"),
            subHeader: "Bachelor of Science in Computer Engineering",
            duration: "September 2015 - July 2019",
            desc: "Took courses about Software Engineering, Web Security, Operating Systems, Databases etc. My thesis was about a study on how the activation functions on impacted the performance of neural networks.",
            //descBullets: [""]
        }
    ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
    viewSkillBars: true, //Set it to true to show Proficiency Section
    experience: [
        {
            Stack: "Python development", //Insert stack or technology you have experience in
            progressPercentage: "80%" //Insert relative proficiency in percentage
        },
        {
            Stack: "Machine Learning & Deep Learning",
            progressPercentage: "80%"
        },
        {
            Stack: "Data analysis & data visualization",
            progressPercentage: "70%"
        },
        {
            Stack: "MLOps",
            progressPercentage: "70%"
        }
    ],
    displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
    display: true, //Set it to true to show workExperiences Section
    experience: [
        {
            role: "Freelancer Machine Learning Engineer",
            company: "Joule",
            companylogo: require("./assets/images/jouleLogo.jpg"),
            date: "May 2024 – Present",
            desc: "As a Freelance ML Engineer, I am responsible for all the AI related tasks of the company. The business focus is to help HRs to evaluate candidates based on their soft-skills. My responsabilities are:",
            descBullets: [
                "Design and code ML/DL solutions using SOTA approaches, spanning from images to NLP fields",
                "Create Python code that is efficient, scalable and easy to maintain",
                "Using well known framework such as Redis, RabbitMQ, etc. to perform DevOps tasks and Qdrant, Mlflow, Arize-Pheonix for MLOps tasks"
            ]
        },
        {
            role: "Machine Learning Engineer",
            company: "Previnet",
            companylogo: require("./assets/images/previnetLogo.png"),
            date: "November 2021 – May 2024",
            desc: "As ML Engineer, I am responsible for the development and deployment of machine learning models in the insurance field. What I've done so far:",
            descBullets: [
                "Implemented a model to assign the correct creditor its invoce. TL;DR: bank data are malformed and NLP + BERT is required.",
                "Implemented a chatbot based on LLM to Q&A text files. Both with OpenAI APIs and local LLMs (llama-like)"
            ]
        },
        {
            role: "ML Engineer Intern",
            company: "Mobisec",
            companylogo: require("./assets/images/mobisecLogo.png"),
            date: "March 2021 – September 2021",
            desc: "During this internship I developed my Master's Thesis. It is focused on techniques to classify malicious mobile communication between client and server.",
            descBullets: [
                "Comparison between classical ML approaches vs deep learning ones",
                "No pre-trained models. Every experiment has been done from scratch using scikit-learn and pytorch"
            ]
        },
        {
            role: "Software Engineer Intern",
            company: "Unipiazza",
            companylogo: require("./assets/images/unipiazzaLogo.png"),
            date: "March 2019 – May 2019",
            desc: "First opportunity to get in touch with the tech world outside from the university. I've been a swiss knife since I experimented in a lot of fields.",
            descBullets: [
                "iOS app maintainance and development",
                "Android unlocking and rooting"
            ]
        }
    ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
    showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
    display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
    title: "Big Projects",
    subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
    projects: [
        {
            image: require("./assets/images/saayaHealthLogo.webp"),
            projectName: "Saayahealth",
            projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            footerLink: [
                {
                    name: "Visit Website",
                    url: "http://saayahealth.com/"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            image: require("./assets/images/nextuLogo.webp"),
            projectName: "Nextu",
            projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            footerLink: [
                {
                    name: "Visit Website",
                    url: "http://nextu.se/"
                }
            ]
        }
    ],
    display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
    title: emoji("Achievements And Certifications 🏆 "),
    subtitle:
        "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

    achievementsCards: [
        {
            title: "AI Agentic Design Patterns with AutoGen",
            date: "July 2024",
            subtitle: "This is a course on AutoGen, which is an open source project to create LLM agents. Agents provide a more articulated and refined response to the user thanks to the combination of instances of an LLM that are involved.",
            image: require("./assets/images/deepLearningAI.png"),
            imageAlt: "",
            footerLink: [
                {
                    name: "Certification",
                    url: "https://learn.deeplearning.ai/accomplishments/cf6395ad-468b-498d-9603-f2b788274bb6?usp=sharing"
                }
            ]
        },
        {
            title: "Google Generative AI path",
            date: "August 2023",
            subtitle:
                "This learning path guides you through a curated collection of content on generative AI products and technologies, from the fundamentals of Large Language Models to how to create and deploy generative AI solutions on Google Cloud.",
            image: require("./assets/images/certLogo.png"),
            imageAlt: "Google Code-In Logo",
            footerLink: [
                {
                    name: "Certification",
                    url: "https://www.cloudskillsboost.google/public_profiles/6c45da75-018e-47c8-9c1a-10ff73e90f39"
                },
            ]
        },
        {
            title: "",
            subtitle: "",
            image: "",
            imageAlt: " ",
            footerLink: [

            ]
        },
    ],
    display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
    title: "Blogs",
    subtitle:
        "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
    displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
    display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
    title: "TALKS",
    subtitle: emoji(
        "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
    ),

    talks: [
        {
            title: "Build Actions For Google Assistant",
            subtitle: "Codelab at GDG DevFest Karachi 2019",
            slides_url: "https://bit.ly/saadpasta-slides",
            event_url: "https://www.facebook.com/events/2339906106275053/"
        }
    ],
    display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
    title: emoji("Podcast 🎙️"),
    subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

    // Please Provide with Your Podcast embeded Link
    podcast: [
        "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
    ],
    display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
    title: emoji("Contact Me ☎️"),
    subtitle:
        "Discuss a project or just want to say hi? My Inbox is open for all.",
    number: "+393405532494",
    email_address: "matteomoro996@gmail.com"
};

// Twitter Section

const twitterDetails = {
    userName: "twitter", //Replace "twitter" with your twitter username without @
    display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
    illustration,
    greeting,
    socialMediaLinks,
    splashScreen,
    skillsSection,
    educationInfo,
    techStack,
    workExperiences,
    openSource,
    bigProjects,
    achievementSection,
    blogSection,
    talkSection,
    podcastSection,
    contactInfo,
    twitterDetails,
    isHireable
};
